<template>
  <div v-if="mode">
    <comment :element-uuid="element.uuid" :submission-uuid="main_sid" />
    <fb-select-view
      :uuid="element.uuid"
      :valid="valid"
      :validate="validate"
      @md-selected="updateValue"
      :select="saveData"
      :multiple="saveData.multiple"
      :nid="nid"
    />
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'Select'"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
      @collapse-click="collapsePreview"
    />
    <md-content v-show="!collapse">
      <fb-select-view :select="saveData" :multiple="saveData.multiple" />
    </md-content>
    <md-dialog :md-active.sync="showDialog" md-dynamic-height>
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-field>
          <label>Help Text</label>
          <md-input v-model="tempData.help_text"></md-input>
        </md-field>
        <md-checkbox v-model="tempData.multiple">Multiple</md-checkbox>
        <fb-select-option @save="save" :select="tempData.options" :multiple="tempData.multiple" />
        <md-checkbox v-model="tempData.other">Other Field</md-checkbox>
        <div v-if="tempData.other">
          <md-field>
            <label>Other Label</label>
            <md-input v-model="tempData.other_label"></md-input>
          </md-field>
        </div>
        <md-checkbox v-model="tempData.required">Required</md-checkbox>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "../FbElementMixin";
import FbSelectOption from "./FbSelectOption";
import FbSelectView from "./FbSelectView";

export default {
  name: "FbSelect",
  props: ["element", "mode", "validate"],
  mixins: [FbElementMixin],
  created() {
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      this.saveData.value =
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
          this.element.uuid
        ].value;
      this.$emit("set-value", this.value);
    }
    this.$emit("validation", this.valid);
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true
      };
    },
    valid() {
      if (this.isDraft) {
        return true;
      }
      let val;
      val = !(this.saveData.required === true &&
              (!this.saveData.value.value ||
                      (this.saveData.value.value && this.saveData.value.value.length == 0)));
      return val;
    }
  },
  data() {
    return {
      tempData: {
        multiple: this.element.data.multiple || false,
        other: this.element.data.other || false,
        other_label: this.element.data.other_label || "Enter other",
        label: this.element.data.label || "",
        options: this.element.data.options.slice(0) || [],
        help_text: this.element.data.help_text || "",
        required: this.element.data.required || false,
        value: {}
      },
      saveData: {
        multiple: this.element.data.multiple || false,
        other: this.element.data.other || false,
        other_label: this.element.data.other_label || "Enter other",
        label: this.element.data.label || "",
        options: this.element.data.options.slice(0) || [],
        help_text: this.element.data.help_text || "",
        required: this.element.data.required || false,
        value: {}
      }
    };
  },
  methods: {
    updateValue(val) {
      this.saveData.value = val;
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    }
  },
  components: {
    FbSelectOption,
    FbSelectView
  }
};
</script>

<style scoped>
.md-dialog-content::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
.md-dialog-content::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
